import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import WelcomeSection from './WelcomeSection';
import SavingMoneySection from './SavingMoneySection';
import SavingYouTimeSection from './SavingYouTimeSection';
import FaqAccordionSection from './FaqAccordionSection';
import { generateGraphicBannerElement } from 'apps/scribe/scribeContentProvider';
import ProductsCarouselSavingHubPage from './ProductsCarouselSavingHubPage';
import { msg } from 'api';

class YourSavingsHubPage extends PureComponent {
  static propTypes = {
    firstName: PropTypes.string.isRequired,
    userRegistrationDate: PropTypes.string.isRequired,
    smartPassType: PropTypes.string.isRequired,
    numberDelivered: PropTypes.string.isRequired,
    graphicBanner1: PropTypes.object.isRequired,
    graphicBanner2: PropTypes.object.isRequired,
    carouselProps: PropTypes.shape({
      basketItems: PropTypes.array.isRequired,
      productsDetails: PropTypes.array.isRequired,
      productWarnings: PropTypes.array.isRequired,
      section: PropTypes.shape({
        id: PropTypes.string.isRequired,
        fops: PropTypes.arrayOf(
          PropTypes.shape({
            sku: PropTypes.string.isRequired,
            hash: PropTypes.number.isRequired,
          })
        ).isRequired,
      }).isRequired,
    }).isRequired,
    dispatch: PropTypes.func.isRequired,
    instantShopExists: PropTypes.bool.isRequired,
    oReservedExists: PropTypes.string,

  };

  BASE_NAME = 'YourSavingsHubPage';

  render() {
    const {
      firstName,
      userRegistrationDate,
      smartPassType,
      numberDelivered,
      numberOfCoupons,
      savingsForCoupons,
      pricePromiseVoucherValue,
      pricePromiseVoucherCode,
      graphicBanner1,
      graphicBanner2,
      basketItems,
      productWarnings,
      productsBySku,
      productBySkuCarousel1,
      productBySkuCarousel2,
      productBySkuCarousel3,
      dispatch,
      instantShopExists,
      oReservedExists,
    } = this.props;
    return (
      <div className="your-saving-hub-page">
        <WelcomeSection
          userName={firstName}
          userDayJoined={userRegistrationDate}
          numberDelivered={numberDelivered}
        />
        <SavingMoneySection
          smartPassType={smartPassType}
          couponsToUse={numberOfCoupons}
          couponsSumSavings={savingsForCoupons}
          pricePromiseSum={pricePromiseVoucherValue}
          pricePromiseVoucher={pricePromiseVoucherCode}
        />
        {productBySkuCarousel1 && productBySkuCarousel1.sections.length > 0 && productsBySku && (
        <ProductsCarouselSavingHubPage
          basketItems={basketItems}
          productWarnings={productWarnings}
          productsBySku={productsBySku}
          productBySkuCarousel={productBySkuCarousel1}
          dispatch={dispatch}
          sectionTitle={msg.yourSavingsHub.ProductCarousel1.title}
          sectionText={msg.yourSavingsHub.ProductCarousel1.description}

        />
        )}
        {generateGraphicBannerElement(graphicBanner1, {})}
        {productBySkuCarousel2 && productBySkuCarousel2.sections.length > 0 && productsBySku && (
        <ProductsCarouselSavingHubPage
          basketItems={basketItems}
          productWarnings={productWarnings}
          productsBySku={productsBySku}
          productBySkuCarousel={productBySkuCarousel2}
          dispatch={dispatch}
          sectionTitle={msg.yourSavingsHub.ProductCarousel2.title}
          sectionText={msg.yourSavingsHub.ProductCarousel2.description}
        />
        )}
        <SavingYouTimeSection
          instantShopExists={instantShopExists}
          oReservedExists={oReservedExists}
        />
        {generateGraphicBannerElement(graphicBanner2, {})}
        {productBySkuCarousel3 && productBySkuCarousel3.sections.length > 0 && productsBySku && (
        <ProductsCarouselSavingHubPage
          basketItems={basketItems}
          productWarnings={productWarnings}
          productsBySku={productsBySku}
          productBySkuCarousel={productBySkuCarousel3}
          dispatch={dispatch}
          sectionTitle={msg.yourSavingsHub.ProductCarousel3.title}
          sectionText={msg.yourSavingsHub.ProductCarousel3.description}
        />
        )}
        <section className="section-print" id="small-print">
          {savingsForCoupons === 0 && (
            <>
              <h3 className="section-print__title">{msg.yourSavingsHub.sectionPrint.couponAveragesTitle}</h3>
              <p className="section-print__text">
                <strong className="highlight">*</strong> {msg.yourSavingsHub.sectionPrint.couponAveragesText}
              </p>
            </>
          )}
          <h3 className="section-print__title">{msg.yourSavingsHub.sectionPrint.smartPassAveragesTitle}</h3>
          <p className="section-print__text">
            <strong className="highlight">†</strong>{msg.yourSavingsHub.sectionPrint.smartPassAveragesText}
          </p>
        </section>
        <FaqAccordionSection />
      </div>
    );
  }
}

export default YourSavingsHubPage;
